import { render, staticRenderFns } from "./DisciplinaryList.vue?vue&type=template&id=dd2fb352"
import script from "./DisciplinaryList.vue?vue&type=script&lang=js"
export * from "./DisciplinaryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports